import { useRef } from "react";
import { RotateCw } from "lucide-react";
import usePullToRefresh from "../../Hooks/usePullToRefresh";

/**
 * Drop-in replacement for a mobile page's outer `overflow-y-auto` scroll
 * container that adds a native-feeling pull-to-refresh gesture.
 *
 * Usage: swap `<div className="flex-1 overflow-y-auto ..."> ... </div>`
 * for `<PullToRefreshContainer className="flex-1 overflow-y-auto ..." onRefresh={fn}> ... </PullToRefreshContainer>`.
 */
const PullToRefreshContainer = ({ className = "", onRefresh, disabled, children, ...rest }) => {
	const scrollRef = useRef(null);
	const { indicatorRef, iconRef, isRefreshing } = usePullToRefresh(scrollRef, onRefresh, { disabled });

	return (
		<div ref={scrollRef} className={`relative ${className}`} {...rest}>
			<div
				ref={indicatorRef}
				className="absolute left-0 right-0 flex justify-center pointer-events-none z-10"
				style={{ top: -56, transform: "translateY(0px)", opacity: 0, willChange: "transform, opacity" }}
			>
				<div className="mt-2 bg-sahi-white shadow-md rounded-full p-2 flex items-center justify-center">
					<RotateCw ref={iconRef} className={`h-5 w-5 text-sahi-primary-color ${isRefreshing ? "animate-spin" : ""}`} />
				</div>
			</div>
			{children}
		</div>
	);
};

export default PullToRefreshContainer;
